<template>
  <Container as="section" data-component="GrowArticleRelatedBlock">
    <div class="flex flex-col gap-8 lg:gap-10">
      <Typography as="h2" variant="header-1" class="max-w-3xl">
        {{ title }}
      </Typography>

      <Grid class="gap-y-8 lg:gap-y-10">
        <div v-for="(article, index) in articles" :key="article.link.url || index" class="col-span-12 md:col-span-6 lg:col-span-3">
          <GrowArticleCard
            :title="article.title"
            :image="article.image"
            :link="article.link"
            :tags="article.tags"
            theme="default" />
        </div>
      </Grid>
    </div>
  </Container>
</template>

<script setup lang="ts">
import { Container, Grid, Typography, GrowArticleCard } from '@gro-up/ui/primitives'

// Local placeholder for the future `@gro-up/api/corporate` contract (backend not implemented yet, see
// ticket #5217/#5466) — mirrors the agreed shape exactly. Swap this out for the generated ApiModel once it exists.
type GrowArticleRelatedArticle = {
  title: string
  tags: Array<{ title: string; url: string }>
  link: {
    title: string
    openInNewTab: boolean
    url: string
  }
  image: {
    src: string
    altText: string
    width: number | null
    height: number | null
    focalPointX: number | null
    focalPointY: number | null
  }
}

export type GrowArticleRelatedBlockProps = {
  title: string
  articles: GrowArticleRelatedArticle[]
}

defineProps<GrowArticleRelatedBlockProps>()
</script>
